<template>
  <div>
    <app-warp :title='pageSet.index&&pageSet.index.params.title' >
      <template #app-content>
        <div style="min-height:100%;background-size:100% 100%;" :style="'background-image:url('+oss+pageSet.index.style.backgroundImage+')'" class="moduleMain" ref="appContent">
          <template v-for="(item,key) in pageSet" :key="key">
            <div @click.stop="selectModule(key)" v-if="activeKey==key">
              <component :is="key" :data="item" />
            </div>
          </template>
        </div>
      </template>
      <template #app-sider>
        <a-radio-group v-model:value="activeKey" button-style="solid" @change="changePage" class="m-b-20 m-l-20">
          <a-radio-button value="index">首页</a-radio-button>
          <a-radio-button value="success">中奖页</a-radio-button>
          <a-radio-button value="repeat">重复领奖</a-radio-button>
          <a-radio-button value="notWinning">未中奖</a-radio-button>
        </a-radio-group>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
            <template v-for="(value,index) in formCreateData" :key="value.label+index">
              <a-form-item :label="value.label" :help="value.help">
                <!-- 普通表单 -->
                <template v-if="value.stamp=='input'" >
                  <a-row :gutter="16">
                    <a-col :span="10">
                      <a-input v-model:value="modelRef[value.key][value.name]" :type="value.type" :help="value.help" :maxlength="value.maxLength || 9999" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认设置</a>
                    </a-col>
                  </a-row>
                </template>
                <template v-if="value.stamp=='query'">
                  <a-input-search style="width:200px" v-model:value="modelRef[value.key][value.name]" @search="childrenIndex=indexs;fwVisible=true" readonly placeholder="默认模板">
                    <template #enterButton>
                      <a-button type="primary">
                        选择
                      </a-button>
                    </template>
                  </a-input-search>
                </template>

                <!-- 选择框 -->
                <template v-if="value.stamp=='select'">
                  <a-select v-model:value="modelRef[value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
                    <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
                    </a-select-option>
                  </a-select>
                </template>
                <template v-if="value.stamp=='singleImage'">
                  <div class="s_flex_ali">
                    <div class="width-104 height-104 s_over m-r-20">
                      <material :groupType='1' :image="modelRef[value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{ modelRef[value.key][value.name]=data}" v-on:handledel="modelRef[value.key][value.name]=''" />
                    </div>
                    <a href="javascript:;" v-if="value.defaultValue" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认图</a>
                  </div>
                </template>
                <!-- 单选框 -->
                <template v-if="value.stamp=='radio'">
                  <a-radio-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
                  <a-tooltip placement='right' v-if="value.tips">
                    <template #title>{{value.tips}}
                    </template>
                    <InfoCircleOutlined class="s_c376"/>
                  </a-tooltip>
                </template>
                <!-- 摇一摇图片配置 -->
                <template v-if="value.stamp=='shakeImg'">
                  <a-radio-group :options="[ { label: '默认图标', value: 0 }, { label: '自定义图标', value: 1 } ]" v-model:value="modelRef['style'].shake_img_type" @change="modelRef['style'].shakeBackgroundImage=''" />
                  <div class="s_flex_ali m-t-10" v-if="modelRef['style'].shake_img_type==0">
                    <div class="width-104 height-104 m-r-10 jionImgBox s_flex_center" v-for="(item,indexi) in shake_img" :key="indexi" @click="modelRef['style'].shakeBackgroundImage=item">
                      <div class="width-86 height-86 imaMsak">
                        <img class="width-86" :src="oss+item+'?id=2'" alt="">
                      </div>
                      <CheckSquareFilled v-if="modelRef['style'].shakeBackgroundImage==item" class="jionIcon" />
                    </div>
                  </div>
                  <div class="s_flex_ali m-t-10" v-if="modelRef['style'].shake_img_type==1">
                    <div class="width-104 height-104 s_over">
                      <material :groupType='1' :image="modelRef['style'].shakeBackgroundImage" :max="1" v-on:handlechoose="(data)=>{modelRef['style'].shakeBackgroundImage=data}" v-on:handledel="modelRef['style'].shakeBackgroundImage=''" />
                    </div>
                    <p class="p-l-10 s_c999">推荐宽度220px，高度自定义</p>
                  </div>
                </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
      </template>
    </app-warp>
    <!-- 关联模板 -->
    <a-modal :keyboard="false" title="关联模板" centered v-model:visible="fwVisible" @ok="fwVisible=false" style="width:1200px" :width="1200">
      <fwAudiSelect v-on:select="selecFwAudi" />
    </a-modal>
  </div>
</template>

<script>
import success from "./components/success.vue";
import repeat from "./components/repeat.vue";
import index from "./components/index.vue";
import notWinning from "./components/notWinning.vue";
import config from "@/config";
import forms from "./form";
import * as Icon from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs, watch, watchEffect } from "vue";
import {getCanvas} from '@/libs/html2canvas'
export default {
  components: {
    success,
    repeat,
    index,
    notWinning,
    ...Icon,
  },
  name: "normal",
  props: {
    template_data: Object,
  },
  setup(props, { emit }) {
    // 模板页当前页面 记录
    const state = reactive({
      active: "index",
      fwVisible: false,
      shake_img:[
        '/web_base_assets/scan/shake1.png',
        '/web_base_assets/scan/shake2.gif',
        '/web_base_assets/scan/shake3.gif'
      ]
    });
    const activeKey = ref("index");
    const pageSet = ref({
        index: {
          style: {
            backgroundImage: "/web_base_assets/scan/guideTemplate.png",
            backgroundColor: "#e03319",
            shake_img_type:0,
            shakeBackgroundImage:'/web_base_assets/scan/shake1.png'
          },
          params:{
            title:"导购有礼",
            is_show_shake:false,
            is_show_center:true,
            is_show_goods:true
          }
        },
     success: {
       style: {
            titleColor:"#ffffff",
            awardColor:"#ffffff",
            backgroundImage: "",
            backgroundColor:"#FF3030",
            backgroundButtomImage:"",
            buttonColor: "#FFD5B6",
            buttonTextColor:"#FF211D",
            des_color: "#333333",
            btn_color: "#333333",
          },
          params:{
            jifenTips:"已到账，请前往会员中心查看",
            rebTips:"红包将在24小时内发放",
            envelopesRebTips:"累计满0.3元即可提现"
          }
      },
      repeat: {
        style: {
          icon: "/web_base_assets/scan/guideAwardBg.png",
          buttonColor:'#FFD5B6',
          buttonTextColor:"#FF211D"
        }
      },
      notWinning: {
        style: {
          icon: "/web_base_assets/scan/guideAwardBgNo.png",
          buttonColor:'#FFD5B6',
          buttonTextColor:"#FF211D"
        }
      }
    });
    watchEffect(() => {
      if (JSON.stringify(props.template_data) != "{}") {
        pageSet.value = Object.assign(pageSet.value, props.template_data);
      }
    });
    const activeData = ref({
      is_show: false,
      title: "扫码有礼",
      wait_time: 3,
      backgroundImage: "/web_base_assets/scan/background_default.png",
      backgroundColor: "#fc8c35",
      type: "welcome",
    });
    var modelRef = ref();
    const moduleIndex = ref(0);
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = () => {
      forms.forEach((element) => {
        if (element.type == state.active) {
          formCreateData.value = element.formItems;
        }
      });
    };
    // 模块
    const selectModule = (type) => {
      modelRef.value = pageSet.value[type];
      state.active = type;
      formCreate();
    };
    const initData = () => {
      formCreate();
    };
    const oss = config.oss[process.env.VUE_APP_type];
    onMounted(() => {
      selectModule(activeKey.value);
      initData();
    });
    const submit = () => {
      emit("submit", pageSet.value);
      return pageSet.value;
    };
    const appContent=ref('')
    const getThumb = () => {
     return new Promise((resolve,reject)=>{
          // 选中首页 用于截图
          activeKey.value='index'
          var element= document.getElementById('app-subject')
          getCanvas(element).then(res=>{
              
              resolve(res.image)
          }).catch(()=>{
              reject(pageSet.value["index"].style.backgroundImage)
          })
      })
      
      // // 截图
      
    };
    const changePage = (e) => {
      state.value = e.target.value;
      selectModule(activeKey.value);
      formCreate();
    };
    const selecFwAudi = (data) => {
      pageSet.value["fw"].params.antis_fake_tem_id = data.id;
      pageSet.value["fw"].params.antis_fake_tem_title = data.name;
      pageSet.value["repeatFw"].params.antis_fake_tem_id = data.id;
      pageSet.value["repeatFw"].params.antis_fake_tem_title = data.name;
      state.fwVisible = false;
    };
    return {
      activeKey,
      pageSet,
      selectModule,
      activeData,
      formCreateData,
      ...toRefs(state),
      modelRef,
      moduleIndex,
      oss,
      submit,
      getThumb,
      changePage,
      selecFwAudi,
      appContent
    };
  },
};
</script>
<style lang="less" scoped>
@import url("../module.less");

.jionImgBox{
  position: relative;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  box-sizing: border-box;
  .jionIcon{
    position: absolute;
    bottom: 0;
    right:0;
    font-size: 20px;
    color: #05486A;
  }
}
.joinContent{
  width: 80px;
  position: absolute;
  right: 10px;
  top: 30%;
  text-align: center;
  img{
    width: 100%;
  }
}
.imaMsak{
  background-color: rgba(0, 0, 0, .5);
  border-radius: 100%;
}
</style>